import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/warenlisten-vorgang/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierGoodList"
      returnRoute="/auswahlfelder/dossierGoodList"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierGoodListRoute = Route;
